import { Maybe } from "@/domains/common/types";
import { AppStore } from "@/store/AppStore";
import { FeedbackModelData } from "@/store/feedback/types";
import { OptimisticSyncUpdate, SyncUpdateValue } from "@/store/sync/types";
import { ApiSchema } from "@/modules/api";

export type FeedbackIndexData = {
  feedback_kind: ApiSchema["FeedbackKind"];
  associated_model_id: string | null;
  associated_model_kind: string | null;
  feedback_responded_at: string | null;
};

export class FeedbackIndexes {
  private store: AppStore;
  private data: SyncUpdateValue<FeedbackModelData>;

  constructor({
    store,
    remoteData,
    optimisticUpdates,
  }: {
    store: AppStore;
    remoteData: Maybe<SyncUpdateValue<FeedbackModelData>>;
    optimisticUpdates: OptimisticSyncUpdate<FeedbackModelData>[];
  }) {
    this.store = store;
    this.data =
      (optimisticUpdates.at(-1)?.value as SyncUpdateValue<FeedbackModelData>) || remoteData;
  }

  get feedbackKind(): ApiSchema["FeedbackKind"] {
    return this.data.model_data.feedback_kind;
  }

  get associatedModelId(): string | null {
    return this.data.model_data.associated_model_id;
  }

  get associatedModelKind(): string | null {
    return this.data.model_data.associated_model_kind;
  }

  get feedbackRespondedAt(): string | null {
    return this.data.model_data.feedback_responded_at;
  }

  get indexes(): FeedbackIndexData {
    return {
      feedback_kind: this.feedbackKind,
      associated_model_id: this.associatedModelId,
      associated_model_kind: this.associatedModelKind,
      feedback_responded_at: this.feedbackRespondedAt,
    };
  }
}
